import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const BuyerId = {
  id: 'buyerId',
  displayName: <FormattedMessage {...messages.buyerId} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'BuyerId',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
